// polyfills for old poltergeist
import 'core-js/es/map';
import 'core-js/es/weak-map';
import 'core-js/es/set';
import 'react-app-polyfill/ie9'; // For IE 9-11 support
import 'react-app-polyfill/ie11'; // For IE 11 support
import './styles.scss';

import React from 'react';
import ReactDOM from 'react-dom';
import ToDoList from './todoList/ToDoList';
import Dashboard from './dashboard/Dashboard';
import SessionTimeoutPopup from './session-timeout-popup/SessionTimeoutPopup';

const TodoList = document.getElementById('todo-list');
if (TodoList !== null) {
  ReactDOM.render(
    <ToDoList />, TodoList,
  );
}

const dashboard = document.getElementById('dashboard');
if (dashboard !== null) {
  ReactDOM.render(
    <Dashboard />, dashboard,
  );
}

const sessionTimeoutPopup = document.getElementById('session-timeout-popup');
if (sessionTimeoutPopup !== null) {
  const appName = sessionTimeoutPopup.getAttribute('data-app-name');
  const defaultReCheckTime = parseInt(sessionTimeoutPopup.getAttribute('data-default-recheck-time'), 10) || 60;
  const initialReCheckTime = parseInt(sessionTimeoutPopup.getAttribute('data-init-recheck-time'), 10) || 30;
  ReactDOM.render(
    <SessionTimeoutPopup
      appName={appName}
      defaultReCheckTime={defaultReCheckTime}
      initialReCheckTime={initialReCheckTime}
    />,
    sessionTimeoutPopup,
  );
}
